import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'fitmentListingTireSize',
  title: 'Tire Size Configuration',
  type: 'object',
  fields: [
    defineField({
      name: 'front',
      title: 'Front',
      type: 'reference',
      to: [{ type: 'tireSize' }],
      options: {
        disableNew: true,
      },
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'rear',
      title: 'Rear',
      type: 'object',
      options: {
        collapsible: true,
        collapsed: false,
      },
      fields: [
        {
          name: 'sameAsFront',
          title: 'Same as Front',
          type: 'boolean',
          initialValue: true,
        },
        {
          name: 'size',
          title: 'Size',
          type: 'reference',
          to: [{ type: 'tireSize' }],
          hidden: ({ parent }) => parent?.sameAsFront,
          options: {
            disableNew: true,
          },
          validation: (Rule) =>
            Rule.custom((value, context) => {
              if (!context.parent?.sameAsFront && !value) {
                return 'Required when not same as front'
              }
              return true
            }),
        },
      ],
    }),
    defineField({
      type: 'fitmentListingTireNotes',
      name: 'fitmentListingTireNotes',
      title: 'Tire Notes',
    }),
  ],
})
